import { lazyLoad } from "utils/loadable";

const ChangePasswordPage = lazyLoad(
  () => import("./index"),
  (module) => module.default,
  {
    fallback: (
      <div>
        <p>Loading....</p>
      </div>
    ),
  }
);

export default ChangePasswordPage;
